import { render } from "./IndexHome.vue?vue&type=template&id=87689f80"
import script from "./IndexHome.vue?vue&type=script&lang=js"
export * from "./IndexHome.vue?vue&type=script&lang=js"

import "../assets/style/index.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__